import React from 'react'
import BlogCard from './BlogCard'

const BlogLatestPost = () => {
    return (
        <>
            {/* Latest Post */}
            <div className="_top_post_wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                            <h3 className="_top_post_title">Latest blogs</h3>
                            <span className="_title_line" />
                        </div>
                        <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12">
                            <div className="row">
                                <BlogCard/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Latest Post */}
        </>
    )
}

export default BlogLatestPost